import { createAction } from '@reduxjs/toolkit';
import type { Collection, RecordOf } from 'immutable';

import { errorPayloadCreator, getPayloadCreator } from '../core/actionHelpers';
import type { QcsSyncResourcesPayloadProps } from '../core/resourceStoreTypes';
import type { InvestmentHoldingV2Type } from './investmentHoldingsV2Types';

const holdingPayloadCreator = getPayloadCreator<RecordOf<InvestmentHoldingV2Type>>();
const syncPayloadCreator = getPayloadCreator<QcsSyncResourcesPayloadProps<InvestmentHoldingV2Type>>();
// Callers pass a collection; an undo passes back the array it saved.
const batchPayloadCreator = getPayloadCreator<
  Collection<unknown, RecordOf<InvestmentHoldingV2Type>> | RecordOf<InvestmentHoldingV2Type>[]
>();
const batchSuccessPayloadCreator = getPayloadCreator<RecordOf<InvestmentHoldingV2Type>[]>();

export const getInvestmentHoldingsV2 = createAction('GET_INVESTMENT_HOLDINGS_V2', getPayloadCreator());
export const getInvestmentHoldingsV2Success = createAction('GET_INVESTMENT_HOLDINGS_V2_SUCCESS', syncPayloadCreator);
export const getInvestmentHoldingsV2Failure = createAction('GET_INVESTMENT_HOLDINGS_V2_FAILURE', errorPayloadCreator);

export const createInvestmentHoldingV2 = createAction('CREATE_INVESTMENT_HOLDING_V2', holdingPayloadCreator);
export const createInvestmentHoldingV2Success = createAction(
  'CREATE_INVESTMENT_HOLDING_V2_SUCCESS',
  holdingPayloadCreator,
);
export const createInvestmentHoldingV2Failure = createAction(
  'CREATE_INVESTMENT_HOLDING_V2_FAILURE',
  errorPayloadCreator,
);

export const updateInvestmentHoldingV2 = createAction('UPDATE_INVESTMENT_HOLDING_V2', holdingPayloadCreator);
export const updateInvestmentHoldingV2Success = createAction(
  'UPDATE_INVESTMENT_HOLDING_V2_SUCCESS',
  holdingPayloadCreator,
);
export const updateInvestmentHoldingV2Failure = createAction(
  'UPDATE_INVESTMENT_HOLDING_V2_FAILURE',
  errorPayloadCreator,
);

export const batchInvestmentHoldingsV2 = createAction('BATCH_INVESTMENT_HOLDINGS_V2', batchPayloadCreator);
export const batchInvestmentHoldingsV2Success = createAction(
  'BATCH_INVESTMENT_HOLDINGS_V2_SUCCESS',
  batchSuccessPayloadCreator,
);
export const batchInvestmentHoldingsV2Failure = createAction(
  'BATCH_INVESTMENT_HOLDINGS_V2_FAILURE',
  errorPayloadCreator,
);

export const deleteInvestmentHoldingV2 = createAction('DELETE_INVESTMENT_HOLDING_V2', holdingPayloadCreator);
export const deleteInvestmentHoldingV2Success = createAction(
  'DELETE_INVESTMENT_HOLDING_V2_SUCCESS',
  holdingPayloadCreator,
);
export const deleteInvestmentHoldingV2Failure = createAction(
  'DELETE_INVESTMENT_HOLDING_V2_FAILURE',
  errorPayloadCreator,
);

/** Identifies the one holding QCS should rebuild from its investment transactions. */
export type SyncHoldingFromTransactionsProps = {
  accountId: string;
  localSecurityId: string;
};

const syncHoldingPayloadCreator = getPayloadCreator<SyncHoldingFromTransactionsProps>();

export const syncHoldingFromTransactions = createAction('SYNC_HOLDING_FROM_TRANSACTIONS', syncHoldingPayloadCreator);
export const syncHoldingFromTransactionsSuccess = createAction('SYNC_HOLDING_FROM_TRANSACTIONS_SUCCESS');
export const syncHoldingFromTransactionsFailure = createAction(
  'SYNC_HOLDING_FROM_TRANSACTIONS_FAILURE',
  errorPayloadCreator,
);

export const investmentHoldingsCalc = createAction('INVESTMENT_HOLDINGS_CALC');
export const investmentHoldingsCalcSuccess = createAction('INVESTMENT_HOLDINGS_CALC_SUCCESS');
export const investmentHoldingsCalcFailure = createAction('INVESTMENT_HOLDINGS_CALC_FAILURE', errorPayloadCreator);
